import { render, staticRenderFns } from "./PaymentLayout.vue?vue&type=template&id=34412d12&scoped=true"
var script = {}
import style0 from "./PaymentLayout.vue?vue&type=style&index=0&id=34412d12&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34412d12",
  null
  
)

export default component.exports